import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";
import { ErrorToast } from "../../../components/common/Toast";

export const getAllActivePackages = createAsyncThunk(
  "Package/FindAllActivePackage",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Package/FindAllActivePackage`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Packages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPackagesByURL = createAsyncThunk(
  "Package/FindByURLPackage",
  async (PackageURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Package/FindByURLPackage`,
        { PackageURL },
      );
      return response.data?.Data as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Packages Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
